import ky from 'ky';

import { Sport } from './types';

/**
 * Saves mp4 file to the users Downloads folder
 * @param url link to the file to download.
 * @param name desired name of the file to save to disc.
 */
export async function downloadMP4File(url: string, name: string) {
  let objectUrl: string | undefined;
  let a: HTMLAnchorElement | undefined;
  try {
    const blob = await ky(url).blob();

    // normalize file name by removing spaces:
    const normalizedName = name.trim().replace(/\s+/g, '_');

    objectUrl = URL.createObjectURL(blob);
    a = document.createElement('a');
    a.href = objectUrl;
    a.download = `${normalizedName}.mp4`;
    document.body.appendChild(a);
    a.click();
  } finally {
    a?.remove();
    if (objectUrl) {
      URL.revokeObjectURL(objectUrl);
    }
  }
}

export const isMILBSport = (sportId: number) => {
  return [Sport.AA, Sport.AAA, Sport['A+'], Sport.A, Sport.Minors].some((id) => id === sportId);
};
